export default __webpack_public_path__ + "static/media/app-bar-account.28993d52.svg";